import { FormEvent, useState } from 'react'
import { Alerta, AreaTexto, Boton, Campo, Dialogo } from '../kit'
import { useDarDeBaja, useRevertirBaja } from '../../queries/useInventario'
import { Bien } from '../../types/inventario'
import { mensajeDeError } from '../../utils/errores'

const nombre = (b: Bien) => b.numero || b.descripcion

/**
 * Marcar bienes para dar de baja (`revertir` = deshacerlo). Al marcarlos salen de la
 * plancheta y de la lista de su oficina y pasan a Bajas; el motivo es obligatorio. Al
 * revertir vuelven a la oficina donde estaban, con el estado que tenían.
 */
export function DialogoBaja({
  bienes, revertir = false, onCerrar, onHecho,
}: {
  bienes: Bien[]
  revertir?: boolean
  onCerrar: () => void
  onHecho?: () => void
}) {
  const dar = useDarDeBaja()
  const deshacer = useRevertirBaja()
  const accion = revertir ? deshacer : dar
  const [motivo, setMotivo] = useState('')

  const guardar = (e: FormEvent) => {
    e.preventDefault()
    const listo = {
      onSuccess: () => {
        onHecho?.()
        onCerrar()
      },
    }
    const ids = bienes.map((b) => b.id)
    if (revertir) deshacer.mutate({ bienes: ids, motivo }, listo)
    else dar.mutate({ bienes: ids, motivo }, listo)
  }

  const uno = bienes.length === 1
  const cuales = uno ? nombre(bienes[0]) : `${bienes.length} bienes`
  const oficinas = [...new Set(bienes.map((b) => b.recinto?.nombre ?? 'sin oficina'))]
  return (
    <Dialogo abierto onCerrar={onCerrar} titulo={revertir ? `Revertir la baja de ${cuales}` : `Dar de baja ${cuales}`}>
      <form className="pila" onSubmit={guardar}>
        {bienes.length > 1 && (
          <p className="texto-secundario">
            {bienes.slice(0, 4).map(nombre).join(', ')}
            {bienes.length > 4 && ` y ${bienes.length - 4} más`}
          </p>
        )}
        <p>
          {revertir
            ? uno
              ? `Vuelve a la oficina donde estaba (${oficinas.join(', ')}), con el estado que tenía, y a su plancheta.`
              : `Vuelven a la oficina donde estaban (${oficinas.join(', ')}), con el estado que tenían, y a su plancheta.`
            : uno
              ? 'Sale de la plancheta y de la lista de su oficina, y pasa a Bajas. Se puede revertir: vuelve a la oficina donde estaba.'
              : 'Salen de la plancheta y de la lista de su oficina, y pasan a Bajas. Se puede revertir: vuelven a la oficina donde estaban.'}
        </p>
        <Campo
          etiqueta="Motivo"
          requerido={!revertir}
          ayuda={revertir ? 'Opcional. Queda en el historial.' : 'Por ejemplo: roto, obsoleto o reemplazado. Queda en el historial.'}
        >
          <AreaTexto rows={3} value={motivo} onChange={(e) => setMotivo(e.target.value)} required={!revertir} data-autofocus />
        </Campo>
        {accion.isError && <Alerta tipo="error">{mensajeDeError(accion.error)}</Alerta>}
        <div className="acciones-formulario">
          <Boton variante="text" onClick={onCerrar}>Cancelar</Boton>
          {revertir ? (
            <Boton type="submit" cargando={deshacer.isPending}>Revertir baja</Boton>
          ) : (
            <Boton type="submit" color="error" cargando={dar.isPending} disabled={!motivo.trim()}>Dar de baja</Boton>
          )}
        </div>
      </form>
    </Dialogo>
  )
}
